import { BehaviorSubject } from "rxjs";
import { DomainId } from "../../../../config";
import { Category } from "../../../../models";
import { AutocompleteDefinition } from "../autocomplete-definition";

export class AutocompleteCategoryDefinition implements AutocompleteDefinition<Category> {
  identifier = "identifier";
  initialValues$ = new BehaviorSubject<Array<Category>>(null);
  maximumNumberOfSelectedEntities = 1;
  dataMapper = (data: any) => (data || {}).categoryDomains?.map(cd => ({
    identifier: cd.category?.id,
    label: cd.category?.parent?.categoryDomain ?
      `${cd.category.parent.categoryDomain.name} > ${cd.name}` :
      cd.name,
    alias: cd.alias
  }))

  queryBuilder = (domainId: DomainId, typed: string, limit: string) => `{
      categoryDomains(
        domain: ${domainId}
        limit: ${limit}
        partialName: "${typed}"
        hasPublishedSoftwares: true
        sorts: [{ order: ASC, property: nameLength }]
      ) {
        name
        alias
        category {
          id
          parent {
            id
            categoryDomain(domain: ${domainId}) {
              name
            }
          }
        }
      }
    }
  `

  display(category: Category): string {
    return category.label;
  }

  setMaximumNumberOfSelectedEntities(maxSize: number): AutocompleteDefinition<Category> {
    this.maximumNumberOfSelectedEntities = maxSize;
    return this;
  }
}
